import {createSlice} from '@reduxjs/toolkit';

import accountApi from "./account.api";
import {
    accountAddressChanged, accountAddressChangeFailed,
    accountBalanceUpdated,
    accountDetailsChanged,
    accountPreferencesChanged
} from "./handlers/accountHandlers";
import {transferFailed} from "./handlers/transferHandlers";

const initialState = {
    userAccount: null,
    userTransactions: [],
    userRegistration:{
        error: null,
    },
    userAccountProfileState: {
        updated: false,
        eventName: '',
    },
    lastPictureUpdate: new Date().getTime()
};

const accountSlice = createSlice({
    name: 'account',
    initialState,
    reducers: {
        setAccount: (state, action) => {
            const { account } = action.payload;
            state.userAccount = account;
        },
        setAccountCulture: (state, action) => {
            const { culture } = action.payload;
            state.userAccount.preferences.culture = culture;
        },
        resetRegistrationError: (state) => {
            state.userRegistration.error = null;
        },
        resetUserAccountProfileState: (state) => {
            state.userAccountProfileState.updated = false;
            state.userAccountProfileState.eventName = '';
        },
        setLastPictureUpdate: (state) => {
            state.lastPictureUpdate = new Date().getTime();
        }
    },
    extraReducers: (builder => {
        builder.addCase("ws/accountBalanceUpdated", accountBalanceUpdated)
        builder.addCase("ws/accountAddressChanged", accountAddressChanged)
        builder.addCase("ws/accountDetailsChanged", accountDetailsChanged)
        builder.addCase("ws/accountPreferencesChanged", accountPreferencesChanged)
        builder.addCase("ws/accountAddressChangeFailed", accountAddressChangeFailed)
        builder.addCase("ws/transferFailed", transferFailed)
        builder.addMatcher(accountApi.endpoints.getAccount.matchFulfilled, (state, action) => {
            state.userAccount = action.payload;
        })
        builder.addMatcher(accountApi.endpoints.register.matchRejected, (state, action) => {
            state.userRegistration.error = action.payload.data;
        })
        builder.addMatcher(accountApi.endpoints.updateAccountCulture.matchFulfilled, (state, action) => {
            state.userAccount.preferences.culture = action.meta.arg.originalArgs;
        })
        builder.addMatcher(accountApi.endpoints.logOut.matchFulfilled, (state, action) => {
            state.userAccount = null;
        })
        builder.addMatcher(accountApi.endpoints.getTransactions.matchFulfilled, (state, action) => {
            state.userTransactions = action.payload;
        })
    })
});

export const {
    setToken,
    setAccount,
    logOut,
    setAccountCulture,
    resetRegistrationError,
    resetUserAccountProfileState,
    setLastPictureUpdate
} = accountSlice.actions;

export default accountSlice.reducer;
